import React from 'react';
import { mdiCog } from '@mdi/js';
import { Button, Tooltip } from 'antd';
import useQueryParams from 'hooks/useQueryParams';
import Icon from '@mdi/react';
import Ninja from '@ninja';

const CampaignSpentActionButton = ({ id, integration_type, size = 1 }) => {
  const { setUrlParams } = useQueryParams();

  return (
    <Tooltip title='Config'>
      <Button
        type='text'
        shape='circle'
        icon={<Icon path={mdiCog} size={size} color={Ninja.colors.light} />}
        onClick={() => {
          if (id.length > 0) {
            setUrlParams({ store_id: id, integration_type: integration_type });
          } else {
            setUrlParams({ integration_type: integration_type, store_id: 'all' });
          }
        }}
      />
    </Tooltip>
  );
};

export default CampaignSpentActionButton;
